import { useEffect, useRef } from "react";
import "./MediaPage.css";

export function MediaPage(): JSX.Element {
    const audioRef = useRef<HTMLAudioElement | null>(null);
    const gainNodeRef = useRef<GainNode | null>(null);
    const audioCtxRef = useRef<AudioContext | null>(null);

    useEffect(() => {
        if (!audioRef.current) {
            console.error("Audio element not found");
            return;
        }

        const audioCtx = new AudioContext();
        const audioElement = audioRef.current;

        // Create MediaElementAudioSourceNode
        const source = audioCtx.createMediaElementSource(audioElement);

        // Create gain node
        const gainNode = audioCtx.createGain();
        gainNodeRef.current = gainNode;

        // Connect source to gain node and gain node to destination
        source.connect(gainNode);
        gainNode.connect(audioCtx.destination);

        // Set up event listener for mouse movement to adjust volume
        const updatePage = (e: MouseEvent) => {
            const curY = e.pageY;
            const HEIGHT = window.innerHeight;
            if (gainNodeRef.current) {
                gainNodeRef.current.gain.value = curY / HEIGHT;
            }
        };

        document.addEventListener("mousemove", updatePage);

        // Clean up event listener and audio context when component unmounts
        return () => {
            document.removeEventListener("mousemove", updatePage);
            audioCtx.close();
        };
    }, []);

    return (
        <div className="MediaPage">
            <h1>Media Page</h1>
            <h2>Undnder Construction</h2>
            <h2>Come back again to check this feature out!</h2>
            <audio ref={audioRef} controls>
                <source src="your-audio-file.mp3" type="audio/mp3" />
                Your browser does not support the audio element.
            </audio>
        </div>
    );
}
